import React, { FC, useState } from 'react';
import styles from './SitePreviewPremiumContent.scss';
import Success from 'assets/svgs/success.svg';
import { useMsId } from 'stores/appStore';
import { useSessionId } from 'hooks';
import { redirectToPremium } from 'utils/premium';
import { assertString } from '@wix/gg-common-lib/utils';
import { Trans, useTranslation } from '@wix/wix-i18n-config';

export const SitePreviewPremiumContent: FC = () => {
  const { t } = useTranslation();
  const msId = useMsId();
  const sessionId = useSessionId();

  const [isLoading, setIsLoading] = useState(false);

  const handleUpgrade = async () => {
    try {
      setIsLoading(true);
      assertString(msId);
      await redirectToPremium({ metaSiteId: msId, sessionId });
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.sitePreviewPremiumContent}>
      <Success />
      <p className={styles.sitePreviewPremiumContentTitle}>
        <Trans
          i18nKey="site_preview.premium.content.title"
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
      <p className={styles.sitePreviewPremiumContentSubtitle}>
        <Trans
          i18nKey="site_preview.premium.content.subtitle"
          components={{
            br: <br />,
          }}
        />
      </p>
      <div className={styles.sitePreviewPremiumContentBanner}>
        <div>
          <p>{t('site_preview.premium.content.banner.urgency')}</p>
          <p>{t('site_preview.premium.content.banner.discount')}</p>
          <p>{t('site_preview.premium.content.banner.description')}</p>
        </div>
        <button onClick={handleUpgrade} disabled={isLoading}>
          {t('site_preview.premium.content.banner.button')}
        </button>
        <div>
          <p>{t('site_preview.premium.content.banner.footer_prefix')}</p>
          <p>{t('site_preview.premium.content.banner.footer_highlight')}</p>
        </div>
      </div>
    </div>
  );
};
